<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div ref="dynamicDialog" class="modal specsheet-model">
            <div class="modal__header">
                <h2 class="headline-s">Spec Sheet</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body flex-column">
               
                <div class="input-folder">
                    <div class="input-folder--input">
                        <PrimeInputText
                            id="emailInput" v-model="form.email" placeholder=" "
                            :class="{'invalid-state-input': form.errors?.email != null}"
                            fluid
                        />
                        <label for="emailInput">
                            <p class="paragraph-default">Email *</p>
                        </label>
                    </div>
                    <div class="input-folder">
                        <p class="input-support-text" v-if="!form.errors?.email">* Email address is only required to email the spec sheet</p>
                        <p class="input-support-text invalid-state" v-if="form.errors?.email">{{ form.errors.email }}</p>
                    </div>
                </div>
                <Recaptcha v-if="!isLoggedIn" ref="recaptcha" v-model="captchaResponse" theme="light" />
                <div class="flex-row-forced" style="gap: 1rem; flex-flow: row wrap;">
                    <RothcoCta id="submitButton" :class="emailValid ? `primary` : `disabled`" @click="sendEmail">Email Me</RothcoCta>
                    <RothcoCta id="submitButton" :class="captchaValid ? `primary` : `disabled`" @click="viewSpecSheet">View</RothcoCta>
                    <RothcoCta id="submitButton" :class="captchaValid ? `primary` : `disabled`" @click="download">Download</RothcoCta>
                </div>
            </div>
        </div>
    </div>    
</template>
<script lang="ts" setup>
    import { inject, ref, computed } from "vue";
    import { onClickOutside } from "@vueuse/core";
    import Recaptcha from "@/components/Recaptcha.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { useSettingsStore } from "@/store/settings";
    import { useFetch } from "@/helpers/composables/useFetch";
    import { storeToRefs } from "pinia";
    import { useForm } from "@/helpers/composables/useForm";
    import { string, object } from "yup";
    import CloseIcon from "@icons/closeIcon.svg";
    let settings = useSettingsStore();

    let { user } = storeToRefs(settings);
    let { setOverlayMessage, setNotificationMessage} = settings;

    const dialogRef = inject('dialogRef');
    let dynamicDialog = ref();

    let spec_sheet = dialogRef?.value?.data?.spec_sheet ?? null;

    let form = useForm({
        useInertia: false,
        schema: object({
            email: string().email('Must be a valid email').required("Email is required for receiving an email").default(''),
        })
    });

    let recaptcha = ref();
    let captchaResponse = ref();

    let isLoggedIn = computed(()=>{
        return user.value?.user_id != null;
    });

    let captchaValid = computed(()=>{
        if(isLoggedIn.value) return true;
        return captchaResponse.value != null && captchaResponse.value != "";
    });

    let emailValid = computed(()=>{
        return spec_sheet != null && spec_sheet != '' && captchaValid.value &&
            form.email != null && form.email != '' && (form.errors?.email == null || form.errors?.email == '');
    });

    const closeDialog = () => {
        dialogRef?.value?.close();
    };

    const viewSpecSheet = () => {
        if(captchaValid.value){
            window.open(spec_sheet, '_blank');
            closeDialog();
        }
    };

    const sendEmailLoading = ref(false);
    const sendEmail = () => {
        if(emailValid.value){
            const { data: postResponse } = useFetch(spec_sheet + `?email=${form.email}`, {immediate: true, 

                afterFetch(ctx){
                    sendEmailLoading.value = false;
                    setOverlayMessage(null);
                    setNotificationMessage({
                        message: `Email has been sent, Please check your inbox.`,
                        type: 'success'
                    })
                },
                onFetchError(ctx){
                    sendEmailLoading.value = false;
                    setNotificationMessage({
                        message: `Error sending email. Please try again.`,
                        type: 'error'
                    })
                },
                beforeFetch(ctx){
                    let { cancel } = ctx;
                    ctx.options.headers = {
                        ...ctx.options.headers,
                        'Accept': 'application/json',
                    }
                    if(sendEmailLoading.value){
                        cancel()
                    }
                    closeDialog();
                    setOverlayMessage('Processing you request. Please wait...');
                    sendEmailLoading.value = true;
                    return ctx;
                }
            }).get().json();
        }
    };

    const download = () => {
        if(captchaValid.value){
            if(!spec_sheet.includes('.pdf')){
                spec_sheet += `.pdf`;
            }
            window.location.href = spec_sheet + `?download=1`;
            closeDialog();
        }
    };

    onClickOutside(dynamicDialog, ()=>{
        closeDialog();
    });

</script>
